<template>
  <div
    ref="modal"
    class="modal"
    tabindex="-1"
    role="dialog"
    @hidden="hidden"
    id="modal-correo"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center">
            <b>Enviar Certificado a los participantes</b>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form-horizontal">
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"
                >De:</label
              >
              <div class="col-sm-5">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="decorreo"
                />
              </div>
             <!--  <div class="col-sm-5">
                <input
                  class="form-control input-sm"
                  type="password"
                  v-model="declave"
                />
              </div> -->
            </div>
            <!--  <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Nombre: </label>
                        <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="xasunto"> </div>
            </div>-->

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"
                >Asunto:</label
              >
              <div class="col-sm-10">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="xasunto"
                />
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-12">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <th>
                        <small>Nro</small>
                      </th>
                      <th>
                        <small>Participante</small>
                      </th>
                      <th>
                        <small>Correo</small>
                      </th>
                      <th>
                        <small>Estado</small>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="ind" v-for="(e, ind) in correos">
                      <td>
                        <small>{{ ind + 1 }}</small>
                      </td>
                      <td>
                        <small>{{ e.xestudiante }}</small>
                      </td>
                      <td>
                        <small>
                          <input
                            type="email"
                            v-model="e.xcorreo"
                            style="border: 0"
                          />
                        </small>
                      </td>
                      <td>
                        <small>{{ e.xestado }}</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"
                >Mensaje:</label
              >
              <div class="col-sm-10">
                <small class="text-danger">
                  <b>$nombre,$pro y $link</b> se reemplazan automaticamente con
                  los datos del participante
                </small>
                <!-- <ckeditor v-model="xbody" :config="editorConfig"></ckeditor> -->
                <textarea
                  class="form-control"
                  type="text"
                  v-model="xbody"
                  rows="15"
                ></textarea>
                <!-- <ckeditor v-model="xbody" :config="editorConfig"></ckeditor> -->
              </div>
            </div>
          </form>

          <p class="text-center text-danger">{{ msg }}</p>
        </div>

        <!-- <Alertas
          ref="alertar"
          v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
          v-bind:msgLoading="'Aplicando...'"
        /> -->
        <div class="modal-footer">
          <button
            @click="submit"
            v-if="activo"
            type="button"
            class="btn btn-azul"
          >
            Enviar
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Alertas from "@/components/AAlertas.vue";

export default {
  props: {
    xbody: {
      type: String,
      required: true,
    },
    correos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      decorreo: process.env.VUE_APP_EMAIL_DEFAUL_CORP,
      declave: process.env.VUE_APP_PASSWORD_DEFAUL_CORP,
      xnombre: "Certificado " + process.env.VUE_APP_NAME,
      xasunto: "Certificado " + process.env.VUE_APP_NAME,
      activo: true,
      msg: null,
      editorData: "<p>Contenido of the editor.</p>",
      editorConfig: {},
      sendEmailsContadorErr: 0,
    };
  },
  watch: {
    xbody: function () {
      //this.$refs.alertar.reset();
      this.activo = true;
      this.msg = "";
      this.editorData = this.xbody;
      //   window.console.log("MODALLLLLLLLLLLLLLLLll");
    },
    correos: function () {
      if (this.correos.length == 1) {
        var body = this.xbody.replace("\n", " ");
        body = body.replace("$nombre", this.correos[0].xestudiante);
        body = body.replace("$pro", this.correos[0].xpro.toUpperCase());
        body = body.replace("$link", this.correos[0].xlink);
        this.xbody = body;
      }
    },
  },
  components: {  },
  methods: {
    hidden() {
      //this.$refs.alertar.cargando();
    },
    submit() {
      if (this.correos.length == 1) {
        this.enviarUno();
      } else {
        this.enviarVarios();
      }
    },
    enviarUno() {
      var vue = this;
      let e = this.correos[0];
      var body = vue.xbody.replace("\n", " ");
      body = body.replace("$nombre", e.xestudiante);
      body = body.replace("$pro", e.xpro);
      body = body.replace("$link", e.xlink);

      e.xestado = "ENVIANDO...";
      let toemail = e.xcorreo;
      window.Email.send({
        Host: 'smtp.gmail.com',
        Username: 'desam@esam.edu.bo',
        Password: 'cilkzzjmidixiser',
        To: toemail,
        From: vue.decorreo,
        Subject: vue.xasunto,
        Body: body,
      }).then((message) => {
        window.console.log(message);
        e.xestado = `${message}`;
      });
    },
    enviarVarios() {
      var vue = this;
      if (this.sendEmailsContadorErr > 2) {
        this.sendEmailsContadorErr = 0;
        this.loading = false;
        return;
      }
      let firtserr = false;
      this.correos.reduce(async (a,e) => {
        await a;
        if (!firtserr) {
          var body = vue.xbody.replace("\n", " ");
          body = body.replace("$nombre", e.xestudiante);
          body = body.replace("$pro", e.xpro);
          body = body.replace("$link", e.xlink);
          //body = body+' '+e.xlink;

          e.xestado = "ENVIANDO...";
          let toemail = e.xcorreo;
          await window.Email.send({
            Host: 'smtp.gmail.com',
            Username: 'desam@esam.edu.bo',
            Password: 'cilkzzjmidixiser',
            To: toemail,
            From: vue.decorreo,
            Subject: vue.xasunto,
            Body: body,
          }).then((message) => {
            window.console.log(message);
            e.xestado = message;
            if (message != 'OK') {
              firtserr = true;
              vue.sendEmailsContadorErr += 1;
              vue.enviarVarios();
            } else {
              vue.sendEmailsContadorErr = 0;
            }
          });
        }
      }, Promise.resolve());
    },

    enviar(data, estudiante) {
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
        .then(() => {
          window.Email &&
            window.Email.send({
              Host: process.env.VUE_APP_EMAIL_HOST,
              Username: this.decorreo,
              Password: this.declave,
              From: this.decorreo,
              Subject: this.xasunto,
              To: estudiante.xcorreo, //"kryshot05@gmail.com",
              Body: estudiante.xbody,
            }).then((message) => {
              estudiante.xestado = message;
            });
        })
        .catch((error) => {
          window.console.log("no llamo el enlace: ", error);
        });
    },
    enviarMultiple({ data: { recievers } }) {
      var vue = this;
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
        .then(() => {
          recievers.forEach(function (estudiante) {
            window.Email &&
              window.Email.send({
                Host: process.env.VUE_APP_EMAIL_HOST,
                Username: vue.decorreo,
                Password: vue.declave,
                From: vue.decorreo,
                To: estudiante.addr,
                // To: "kryshot05@gmail.com",
                Subject: estudiante.subject,
                Body: estudiante.msj,
              }).then((message) => {
                let est = vue.correos.find((x) =>
                  [estudiante.addr].includes(x.xcorreo)
                );
                est.xestado = est ? message : "Error";
              });
          });
        })
        .catch((error) => {
          window.console.log("Error de smtpjs: ", error);
        });
    },
  },
};
</script>